module.exports = __webpack_public_path__ + "static/media/capstone.9ff6a0e2.png";